export class AudioManager {
    constructor(camera) {
        this.camera = camera;
        this.zones = [];
        this.activeZone = null;
        this.audioElements = {};
        this.fadeDuration = 1.5; // seconds
        this.started = false;
        this.muted = false;
    }

    addZone(name, bounds, audioUrl, volume = 0.4) {
        const audio = new Audio(audioUrl);
        audio.loop = true;
        audio.volume = 0;
        audio.preload = 'auto';
        this.audioElements[name] = { audio, targetVolume: volume };
        this.zones.push({ name, bounds });
    }

    start() {
        if (this.started) return;
        Object.values(this.audioElements).forEach(z => {
            z.audio.play().catch(() => {});
        });
        this.started = true;
    }

    toggleMute() {
        this.muted = !this.muted;
        if (this.muted) {
            Object.values(this.audioElements).forEach(z => {
                z.audio.volume = 0;
            });
        }
        return this.muted;
    }

    update() {
        if (!this.started || this.muted) return;
        const pos = this.camera.position;
        let newZone = null;

        for (const zone of this.zones) {
            const b = zone.bounds;
            if (pos.x >= b.minX && pos.x <= b.maxX &&
                pos.y >= b.minY && pos.y <= b.maxY &&
                pos.z >= b.minZ && pos.z <= b.maxZ) {
                newZone = zone.name;
                break;
            }
        }

        // Crossfade between zones
        Object.entries(this.audioElements).forEach(([name, z]) => {
            const target = name === newZone ? z.targetVolume : 0;
            const current = z.audio.volume;
            const step = (1 / 60) / this.fadeDuration;
            if (current < target) {
                z.audio.volume = Math.min(current + step, target);
            } else if (current > target) {
                z.audio.volume = Math.max(current - step, 0);
            }
        });

        this.activeZone = newZone;
    }

    dispose() {
        Object.values(this.audioElements).forEach(z => {
            z.audio.pause();
            z.audio.src = '';
        });
        this.audioElements = {};
        this.zones = [];
    }
}
